var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDebugStartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_5537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5H10.7437C10.4625 4.5125 10.075 4.09063 9.60937 3.775L10.625 2.75937L9.74062 1.875L8.38125 3.23438C8.1 3.16563 7.80312 3.125 7.5 3.125C7.19687 3.125 6.9 3.16563 6.61875 3.23438L5.25937 1.875L4.375 2.75937L5.39062 3.775C4.925 4.09063 4.5375 4.5125 4.25625 5H2.5V6.25H3.80625C3.77187 6.45312 3.75 6.6625 3.75 6.875V7.5H2.5V8.75H3.75V9.375C3.75 9.5875 3.77187 9.79688 3.80625 10H2.5V11.25H4.25625C4.90312 12.3687 6.1125 13.125 7.5 13.125C8.8875 13.125 10.0969 12.3687 10.7437 11.25H12.5V10H11.1937C11.2281 9.79688 11.25 9.5875 11.25 9.375V8.75H12.5V7.5H11.25V6.875C11.25 6.6625 11.2281 6.45312 11.1937 6.25H12.5V5ZM8.75 10H6.25V8.75H8.75V10ZM8.75 7.5H6.25V6.25H8.75V7.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_5537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebugStartIcon);
export default __webpack_public_path__ + "static/media/debug-start-icon.2aaa009af7ea892ab773c6e872917c54.svg";
export { ForwardRef as ReactComponent };